module.exports = require("ngx-bootstrap/locale");